<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
  >
    <g clip-path="url(#clip0_2331_10583)">
      <path
        d="M25.1271 0H7.87292C3.80097 0 0.5 3.30097 0.5 7.37292V24.6271C0.5 28.699 3.80097 32 7.87292 32H25.1271C29.199 32 32.5 28.699 32.5 24.6271V7.37292C32.5 3.30097 29.199 0 25.1271 0Z"
        fill="url(#paint0_linear_2331_10583)"
      />
      <path
        d="M28.5856 15.1829C28.5856 20.7556 23.1747 25.2732 16.5001 25.2732C15.7713 25.2732 15.0576 25.2193 14.3644 25.1161C13.4891 24.9858 12.5901 25.2313 11.8827 25.7631C11.6133 25.9656 11.3136 26.1694 11.0084 26.3373C10.0163 26.883 8.94567 27.0214 8.76609 26.8504C8.58652 26.6793 9.12714 26.2613 9.6212 25.6152C9.702 25.5096 9.78075 25.3942 9.85596 25.2751C10.2992 24.5736 9.93801 23.6894 9.23553 23.2476C6.30761 21.4062 4.41455 18.4791 4.41455 15.1829C4.41455 9.6102 9.8254 5.09265 16.5001 5.09265C23.1747 5.09265 28.5856 9.6102 28.5856 15.1829Z"
        fill="#C3F0B9"
      />
      <g filter="url(#filter0_i_2331_10583)">
        <path
          d="M28.5856 15.1829C28.5856 20.7556 23.1747 25.2732 16.5001 25.2732C14.3301 25.2732 12.2937 24.7957 10.5333 23.9597C6.87908 22.2242 4.41455 18.9439 4.41455 15.1829C4.41455 9.6102 9.8254 5.09265 16.5001 5.09265C23.1747 5.09265 28.5856 9.6102 28.5856 15.1829Z"
          fill="#EDF3EC"
        />
        <path
          d="M28.5856 15.1829C28.5856 20.7556 23.1747 25.2732 16.5001 25.2732C14.3301 25.2732 12.2937 24.7957 10.5333 23.9597C6.87908 22.2242 4.41455 18.9439 4.41455 15.1829C4.41455 9.6102 9.8254 5.09265 16.5001 5.09265C23.1747 5.09265 28.5856 9.6102 28.5856 15.1829Z"
          fill="url(#paint1_radial_2331_10583)"
        />
        <path
          d="M28.5856 15.1829C28.5856 20.7556 23.1747 25.2732 16.5001 25.2732C14.3301 25.2732 12.2937 24.7957 10.5333 23.9597C6.87908 22.2242 4.41455 18.9439 4.41455 15.1829C4.41455 9.6102 9.8254 5.09265 16.5001 5.09265C23.1747 5.09265 28.5856 9.6102 28.5856 15.1829Z"
          fill="url(#paint2_radial_2331_10583)"
        />
        <path
          d="M28.5856 15.1829C28.5856 20.7556 23.1747 25.2732 16.5001 25.2732C14.3301 25.2732 12.2937 24.7957 10.5333 23.9597C6.87908 22.2242 4.41455 18.9439 4.41455 15.1829C4.41455 9.6102 9.8254 5.09265 16.5001 5.09265C23.1747 5.09265 28.5856 9.6102 28.5856 15.1829Z"
          fill="url(#paint3_radial_2331_10583)"
        />
        <path
          d="M28.5856 15.1829C28.5856 20.7556 23.1747 25.2732 16.5001 25.2732C14.3301 25.2732 12.2937 24.7957 10.5333 23.9597C6.87908 22.2242 4.41455 18.9439 4.41455 15.1829C4.41455 9.6102 9.8254 5.09265 16.5001 5.09265C23.1747 5.09265 28.5856 9.6102 28.5856 15.1829Z"
          fill="url(#paint4_radial_2331_10583)"
          fill-opacity="0.1"
        />
      </g>
      <mask
        id="mask0_2331_10583"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        x="4"
        y="5"
        width="25"
        height="22"
      >
        <path
          d="M28.5856 15.1829C28.5856 20.7556 23.1747 25.2732 16.5001 25.2732C15.7713 25.2732 15.0576 25.2193 14.3644 25.1161C13.4891 24.9858 12.5901 25.2313 11.8827 25.7631C11.6133 25.9656 11.3136 26.1694 11.0084 26.3373C10.0163 26.883 8.94567 27.0214 8.76609 26.8504C8.58652 26.6793 9.12714 26.2613 9.6212 25.6152C9.702 25.5096 9.78075 25.3942 9.85596 25.2751C10.2992 24.5736 9.93801 23.6894 9.23553 23.2476C6.30761 21.4062 4.41455 18.4791 4.41455 15.1829C4.41455 9.6102 9.8254 5.09265 16.5001 5.09265C23.1747 5.09265 28.5856 9.6102 28.5856 15.1829Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_2331_10583)">
        <g filter="url(#filter1_f_2331_10583)">
          <path
            d="M11.3589 23.1894C12.195 24.7096 9.5727 27.2559 8.5086 26.6668C7.44451 26.0777 7.85241 24.2724 8.29957 23.5123C8.7467 22.7523 10.5229 21.6691 11.3589 23.1894Z"
            fill="url(#paint5_radial_2331_10583)"
          />
        </g>
        <g filter="url(#filter2_f_2331_10583)">
          <path
            d="M8.48044 26.6804C9.53404 27.6587 13.2667 25.4822 12.7393 23.5001C12.4221 22.3078 11.0824 21.8391 11.5459 23.5001C11.9732 25.0312 9.58706 27.2598 8.58442 26.7047C8.48595 26.6502 8.4001 26.5853 8.32568 26.5118C8.37144 26.5706 8.4229 26.6269 8.48044 26.6804Z"
            fill="url(#paint6_radial_2331_10583)"
            fill-opacity="0.9"
          />
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="filter0_i_2331_10583"
        x="4.41455"
        y="-38.9073"
        width="24.1709"
        height="64.1805"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-60" />
        <feGaussianBlur stdDeviation="22" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.766738 0 0 0 0 0.970833 0 0 0 0 0.728125 0 0 0 0.7 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_2331_10583"
        />
      </filter>
      <filter
        id="filter1_f_2331_10583"
        x="4.83496"
        y="19.4229"
        width="9.68604"
        height="10.3308"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="1.5"
          result="effect1_foregroundBlur_2331_10583"
        />
      </filter>
      <filter
        id="filter2_f_2331_10583"
        x="-5.67432"
        y="8.42297"
        width="32.4644"
        height="32.4993"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="7"
          result="effect1_foregroundBlur_2331_10583"
        />
      </filter>
      <linearGradient
        id="paint0_linear_2331_10583"
        x1="16.5"
        y1="0"
        x2="16.5"
        y2="32"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#83F281" />
        <stop offset="1" stop-color="#59C14C" />
      </linearGradient>
      <radialGradient
        id="paint1_radial_2331_10583"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(16.5001 19.7785) rotate(-90) scale(12.6281 23.3684)"
      >
        <stop stop-color="#C5D9BF" />
        <stop offset="1" stop-color="#C5D9BF" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_2331_10583"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(16.5001 9.95346) rotate(83.5203) scale(10.7767 13.0335)"
      >
        <stop offset="0.53925" stop-color="#BAD6B2" stop-opacity="0.13" />
        <stop offset="1" stop-color="#A9D09E" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_2331_10583"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(8.08201 11.8816) rotate(-6.7348) scale(20.646 16.0949)"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_2331_10583"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(16.044 15.1829) rotate(-92.7207) scale(9.60798 11.5042)"
      >
        <stop stop-color="#EEFDEC" stop-opacity="0" />
        <stop offset="1" stop-color="#EEFDEC" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_2331_10583"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(9.22214 25.8117) rotate(-62.4142) scale(3.81625 2.05175)"
      >
        <stop stop-color="white" />
        <stop offset="0.890251" stop-color="white" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint6_radial_2331_10583"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(10.153 26.4134) rotate(-49.9206) scale(4.07289 2.18973)"
      >
        <stop stop-color="#8AC983" />
        <stop offset="0.890251" stop-color="#8AC983" stop-opacity="0" />
      </radialGradient>
      <clipPath id="clip0_2331_10583">
        <rect width="32" height="32" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
</template>
